import { render, staticRenderFns } from "./HeaderFavorites.vue?vue&type=template&id=313b6ce0"
import script from "./HeaderFavorites.vue?vue&type=script&lang=js"
export * from "./HeaderFavorites.vue?vue&type=script&lang=js"
import style0 from "./HeaderFavorites.vue?vue&type=style&index=0&id=313b6ce0&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderBadge: require('/app/components/HeaderBadge.vue').default})
